<template>
  <el-dialog
    :title="$t('text.pod_change_history')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="600px"
    class="edit-group"
  >
    <div>
      <el-form label-width="140px" :model="form" ref="form">
        <el-form-item prop="AllocatedPod" :label="$t('text.pod_serial_number')">
          <el-input v-model="form.AllocatedPod" :disabled="true"> </el-input>
        </el-form-item>
      </el-form>
      <el-table
        border
        ref="table"
        :data="tableData"
        v-loading="loading"
        class="mt-20"
      >
        <el-table-column :label="$t('text.change_date')" prop="ChangedDate">
          <template slot-scope="scope">
            {{ moment(scope.row.ChangedDate).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('text.loggged_in_date')" prop="LoggedDate">
          <template slot-scope="scope">
            {{ moment(scope.row.LoggedDate).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('text.reason')" prop="Reason">
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      dialogVisible: false,
      loading: false,
      form: {
        PodId: '',
        AllocatedPod: ''
      },
      tableData: []
    }
  },
  methods: {
    openDialog(item) {
      this.dialogVisible = true
      this.form.PodId = item.Id
      this.form.AllocatedPod = item.AllocatedPod
      this.getData()
    },
    closeDialog() {
      this.form = {
        PodId: '',
        AllocatedPod: ''
      }
      this.tableData = []
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    getData() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.loading = true
      ApiService.GetPodChangeHistory(
        this.form.PodId,
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.tableData = response.data.data
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
